"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const react_1 = __importStar(require("react"));
require("./index.scss");
const WorkItemPillSection_1 = require("@Components/WorkItemPillSection");
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const BackButton_1 = __importDefault(require("@Components/Buttons/BackButton"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const mobx_react_1 = require("mobx-react");
const ViewWorkHeader = (props) => {
    var _a, _b;
    const { rightsholderStore, workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { work, errors, backText, children } = props;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onClickCatalogNavigate = () => {
        workStore.destroyViewWork();
        workStore.destroyDraftWork();
        if (work.sesacSelectedPropertyId) {
            navigate(navigation_1.default.rightholder.catalog.work(rightsholderStore.currentRightsholderId, work.sesacSelectedPropertyId));
        }
    };
    return (react_1.default.createElement("div", { className: 'view-work-header' },
        react_1.default.createElement(ContentHeader_1.default, { title: (0, string_escape_newlines_1.stringEscapeNewlines)(work.title), content: react_1.default.createElement(react_1.default.Fragment, null,
                work.sesacSelectedPropertyId && (react_1.default.createElement("button", { className: 'catalog-link', onClick: onClickCatalogNavigate }, "View work in catalog")),
                react_1.default.createElement("span", { className: 'error-field' }, (_b = (_a = errors === null || errors === void 0 ? void 0 : errors.title) === null || _a === void 0 ? void 0 : _a._errors) === null || _b === void 0 ? void 0 : _b.join(', '))), navLeft: react_1.default.createElement(BackButton_1.default, { text: backText }), navRight: children },
            react_1.default.createElement(WorkItemPillSection_1.WorkItemPillSection, { work: work }))));
};
exports.default = (0, mobx_react_1.observer)(ViewWorkHeader);
